export default __webpack_public_path__ + "static/media/shark-poseidon.8fdb9927.png";